import React from 'react';
import { AspectRatio, Flex, Image, Text } from '@stockx/ui';

const UserGeneratedContentCreatorHeader = ({
  creator,
  creatorProfilePhoto,
}) => (
  <Flex alignItems="center">
    <AspectRatio w="55px" ratio={1}>
      <Image borderRadius="full" src={creatorProfilePhoto?.url} />
    </AspectRatio>
    <Text
      ml={2}
      maxWidth="300px"
      fontWeight={500}
      fontSize="lg"
      color="grey.700"
    >
      {creator}
    </Text>
  </Flex>
);

export default UserGeneratedContentCreatorHeader;
